import { Injectable } from '@angular/core';
import { SortDirection } from '@capital-access/common/utils';
import { DESC_DIRECTION } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class SortingDirectionService {
  private currentSortDirection: SortDirection = DESC_DIRECTION;

  setSortDirection(direction: SortDirection): void {
    this.currentSortDirection = direction;
  }

  getSortDirection(): SortDirection {
    return this.currentSortDirection;
  }
}
